<div class="col-md-12 mt-4">
    <hr/>
    <h5>Garantias y Colaterales</h5>
</div>
<div class="row" [formGroup]="form">
    <div class="col-md-6">
        <div class="form-check">
            <input class="form-check-input" type="checkbox" formArrayName="colaterals" value="cd" id="cd" (change)="onCheckboxChange($event)">
            <label class="form-check-label">
                CD
            </label>
        </div>
        <div class="form-check">
            <input class="form-check-input" type="checkbox" formArrayName="colaterals"  value="auto" id="auto" (change)="onCheckboxChange($event)">
            <label class="form-check-label" >
                Auto
            </label>
        </div>
        <div class="form-check">
            <input class="form-check-input" type="checkbox" formArrayName="colaterals"  value="certificados" id="certificados" (change)="onCheckboxChange($event)">
            <label class="form-check-label">
                Certificados
            </label>
        </div>
        
    </div>
    <div class="col-md-6">
        <div class="form-check">
            <input class="form-check-input" type="checkbox" formArrayName="colaterals"  value="bienes" id="bienes" (change)="onCheckboxChange($event)">
            <label class="form-check-label">
                Bienes
            </label>
        </div>
        <div class="form-check">
            <input class="form-check-input" type="checkbox" formArrayName="colaterals"  value="propiedades" id="propiedades" (change)="onCheckboxChange($event)">
            <label class="form-check-label">
                Propiedades
            </label>
        </div>
        <div class="form-check">
            <input formArrayName="colaterals" class="form-check-input" type="checkbox" value="otros" id="otros" (change)="onCheckboxChange($event)">
            <label class="form-check-label">
                Otras Colaterales
            </label>
        </div>
    </div>

    <div class="col-md-12">
        <!-- <label class="form-labels mt-4">Información detallada del colateral</label> -->
        <label class="form-labels mt-4" *ngIf="isLoan">Desglose del desembolso de este prestamo</label>
        <label class="form-labels mt-4" *ngIf="!isLoan">Información detallada del colateral</label>
        <div class="input-group">
            <textarea formControlName="colateralsDetails" class="form-control" rows="3"></textarea>
        </div>
    </div>
</div>